import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(Element);
import { NoticeBar, Toast, Dialog, Overlay, Skeleton, Icon, Tab, Tabs } from "vant";

import "vant/lib/notice-bar/style";
import "vant/lib/toast/style";
import "vant/lib/overlay/style";
import "vant/lib/icon/style";
import "vant/lib/dialog/style";
import "vant/lib/tab/style";
import "vant/lib/tabs/style";
import SvgIcon from "@/components/SvgIcon";
import Uitls from "@/utils/";
import "./assets/styles/index.scss";

//全局注册icon-svg
Vue.component("svg-icon", SvgIcon);
Vue.config.productionTip = false;

Vue.use(NoticeBar);
Vue.use(Overlay);
Vue.use(Dialog);
Vue.use(Skeleton);
Vue.use(Icon);
Vue.use(Tab);
Vue.use(Tabs);
Vue.prototype.$timeFormat = Uitls.timeFormat;
Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
